module.exports = __webpack_public_path__ + "static/media/game-background-questions.81818a1a.jpg";